import { createContext, useContext } from 'react';
import { Stores} from "../stores/RootStores";

export const StoreContext = createContext<Stores>({} as Stores);
export const StoreProvider = StoreContext.Provider;

export const useStore = (): Stores => useContext(StoreContext);
